import whiteBackground from '../images/whiteback.jpg';
import mrLarge from '../images/mr_large.png';

export default function Header() {
  return (
    <header
      className="top"
      style={{
        backgroundImage: `url(${whiteBackground})`
      }}
    >
    <img id="logo" src={mrLarge} alt="Modest Robot" />
    <h1>Modest Robot</h1>
    </header>
  )
}